import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/card";

export const GET_DEPARTMENTS = `
	departments (limit: $limit, page: $page) {
		data {
			...CardDepartment
		}
	}
`;

const ADD_DEPARTMENT = `
	create_department (name: $name, parent_id: $parent_id, code: $code, description: $description) {
		code
		id
		name
		parent_id
		description
		can_update
		can_delete
	}
`;

const UPDATE_DEPARTMENT = `
	update_department(id: $id,
		name: $name,
		parent_id: $parent_id,
		code: $code,
		description: $description,
		list_titles: $list_titles) {
			code
			id
			name
			parent_id
			description
	}
`;

const DELETE_DEPARTMENT = `
	delete_department(id: $id) {
		id
	}
`;

const GET_DEPARTMENT = `
	department(id: $id) {
		...CardDetailDepartment
	}
`;

export default {
	init() {},

	fetchDepartments(payload) {
		const queryOptions = {
			query: gql`query Departments ($limit: Int!, $page: Int!) {
				${GET_DEPARTMENTS}
			}
			${fragments.CardDepartment}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				departments: response.data.departments.data
			};
		});
	},
	updateDepartment(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DepartmentsManagementUpdate (
					$id: Int!,
					$name: String!,
					$parent_id: Int,
					$code: String,
					$description: String,
					$list_titles: [TitleInput]
					) {
						${UPDATE_DEPARTMENT}
					}
				`,
				variables: {
					id: payload.id,
					name: payload.name,
					parent_id: payload.parent_id || null,
					code: payload.code || "",
					description: payload.description || "",
					list_titles: payload.list_titles || []
				}
			})
			.then(response => {
				return { department: response.data.update_department };
			});
	},

	addDepartment(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DepartmentsManagementAdd (
					$name: String!,
					$parent_id: Int,
					$description: String,
					$code: String

					) {
						${ADD_DEPARTMENT}
					}
				`,
				variables: {
					name: payload.name,
					parent_id: payload.parent_id || null,
					code: payload.code || "",
					description: payload.description || ""
				}
			})
			.then(response => {
				return { department: response.data.create_department };
			});
	},

	deleteDepartment(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DepartmentsManagementDelete (
					$id: Int!
					) {
						${DELETE_DEPARTMENT}
					}
				`,
				variables: {
					id: payload.id || null
				}
			})
			.then(response => {
				return { department: response.data.delete_department };
			});
	},
	getDetailDepartment(payload) {
		const queryOptions = {
			query: gql`query GetDetailDepartment ($id: Int!) {
				${GET_DEPARTMENT}
			}
			${fragments.CardDetailDepartment}
			`,
			variables: {
				id: payload.id || null
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				department: response.data.department
			};
		});
	}
};
